import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { Tabs } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import HouseholdCard from './HouseholdCard';
import HouseholdModalSkeleton from './HouseholdModalSkeleton';

const GrossLeasesModal = ({
  open,
  onClose,
  propertyName,
  initialTab = 'approved',
  data,
  loading,
  error,
  onTabChange,
  onLoadMore,
  hasMore,
  onLeaseholderClick,
}) => {
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    if (open) {
      // Ensure initialTab is a valid string - either 'approved' or 'not-approved'
      const validInitialTab =
        String(initialTab) === 'not-approved' ? 'not-approved' : 'approved';
      setActiveTab(validInitialTab);
    }
  }, [open, initialTab]);

  const handleTabChange = (event, tabValue) => {
    // approved tab → "approved", not-approved tab → "not-approved"
    const filterType =
      tabValue === 'not-approved' ? 'not-approved' : 'approved';

    setActiveTab(filterType);
    if (onTabChange) {
      onTabChange(filterType);
    }
  };

  const renderContent = () => {
    if (loading && (!data || !data.households)) {
      return <HouseholdModalSkeleton />;
    }

    if (error) {
      return (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="bodySmall" color="error">
            {error}
          </Typography>
        </Box>
      );
    }

    if (!data || !data.households || data.households.length === 0) {
      return (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="bodySmall" color="text.secondary">
            No Leases found.
          </Typography>
        </Box>
      );
    }

    return (
      <Box>
        {data.households.map((household, index) => (
          <HouseholdCard
            key={household.householdId}
            household={household}
            onLeaseholderClick={onLeaseholderClick}
            showDivider={index < data.households.length - 1}
          />
        ))}

        {hasMore && (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <Button variant="outlined" onClick={onLoadMore} disabled={loading}>
              {loading ? 'Loading...' : 'Load More'}
            </Button>
          </Box>
        )}
      </Box>
    );
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Gross leases - ${propertyName}`}
    >
      {/* Tabs */}
      <Box sx={{ px: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          tabs={[
            { label: 'Approved', value: 'approved' },
            { label: 'Not Approved', value: 'not-approved' },
          ]}
        />
      </Box>

      {/* Content */}
      <Box
        sx={{
          maxHeight: '60vh',
          minWidth: '25vw',
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          overflowX: 'hidden',
        }}
      >
        {renderContent()}
      </Box>
    </Modal>
  );
};

export default GrossLeasesModal;
